import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';

import {
  LinkCustom,
  FullImage,
} from '../components/CustomComp'

import {
  BoxFlexColumnCenterCenter
} from '../components/customComponent/box';

import { ButtonSyetemMain } from '../components/customComponent/button'
import { SearchInput } from '../components/customComponent/form';

import AlertMessage from '../components/pop/AlertMessage';
import AdAccountModal from '../components/adAccounts/AdAccountModal';

import {
  ExpandLess,
  ExpandMore,
  AddLinkOutlinedIcon,
  SearchIcon,
  ManageAccountsOutlinedIcon,
  LinkOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
  CloseOutlinedIcon
} from '../constants/images';
import img_filterNoData from '../assets/images/img_filterNoData.svg';
import img_noData from '../assets/images/img_noData.svg';

import { styled } from '@mui/material/styles';
import theme from '../theme';

import { apiList, getCancelData } from '../api/callAPI';
import useUser from '../hook/useUser';
import useCancel from '../hook/useCancel';
// import useAccount from '../hook/useAccount';

import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';
import * as adAccountConstants from '../components/adAccounts/constants';

const headCells = [
  {
    id: 'media',
    orderName: 'adMedia',
    displayName: "account.table.media",
    align: 'left',
    width: '50px',
    maxWidth: '50px',
    sortable: false
  },
  {
    id: 'adAccountId',
    orderName: 'adAccountId',
    displayName: "account.table.accountId",
    align: 'left',
    width: '200px',
    maxWidth: '200px',
    sortable: false
  },
  {
    id: 'adAccountName',
    orderName: 'adAccountName',
    displayName: "account.table.accountName",
    align: 'left',
    width: '500px',
    maxWidth: 'auto',
    sortable: false
  }
];

const RenderTdContent = ({ cell, row }) => {
  return (
    <Box
      sx={{
        minWidth: cell.width
      }}
    >{row[cell.id]}</Box>
  );
}

const AdAccounts = (props) => {
  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { cancelData, setCancelData } = useCancel();

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState(headCells[0].orderName);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [tableData, setTableData] = useState([]);
  const [tableDataLength, setTableDataLength] = useState(0);
  const [selected, setSelected] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState(null);

  const [currentAccount, setCurrentAccount] = useState(false);

  const [isLoadingData, setIsLoadingData] = useState(true);

  const [modalType, setModalType] = useState('');
  const [alertContent, setAlertContent] = useState({
    open: false,
    message: ''
  });

  const [adMediaType, setAdMediaType] = useState('');


  const fetchData = () => {
    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    const call = getCancelData();
    setCancelData(call);

    const params = {
      page,
      size: rowsPerPage,
    };

    if (searchKeyword) {
      params.fuzzySearch = searchKeyword;
    }

    if (adMediaType) {
      params.media = adMediaType;
    }

    apiList.apiGetOwnedAdAccount(params, call.token).then(res => {
      if (res.message === alertConstants.CANCEL_REQUEST) return;

      if (res.status === 200) {
        setTableData(res.data.result.content);
        setTableDataLength(res.data.result.totalElements);
        setIsLoadingData(false);
      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
      }
    });
  };

  useEffect(() => {
    if (!userData || adMediaType === null) return;
    setIsLoadingData(true);

    const timer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(timer);
  }, [userData, page, order, orderBy, rowsPerPage, searchKeyword, adMediaType]);

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    setPage(0);
    setIsLoadingData(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setIsLoadingData(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setIsLoadingData(true);
  };

  const handleSearchInput = (e) => {
    const { value } = e.target;
    setSearchKeyword(value);
    setPage(0);
  }

  const handelCancelSearch = () => {
    setSearchKeyword('');
  }

  const handleSubmit = (data) => {
    if (modalType === adAccountConstants.LINK_AD_ACCOUNT) {
    }
  }

  return (
    <>
      <Typography variant="h2"><FormattedMessage id="account.title" /></Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <LinkCustom to={urlConstants.PAGE_AD_ACCOUNTS_CREATE}>
          <ButtonSyetemMain
            variant="contained"
            startIcon={<AddLinkOutlinedIcon />}
            sx={{
              minWidth: '180px'
            }}
          >
            <FormattedMessage id="account.button.AuthorizedAccounts" />
          </ButtonSyetemMain>
        </LinkCustom>

        <SearchInput
          id="search"
          placeholder={intl.formatMessage({ id: "account.search.accounts" })}
          startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
          endAdornment={
            searchKeyword && (
              <InputAdornment position="end">
                <CloseOutlinedIcon onClick={handelCancelSearch} />
              </InputAdornment>
            )}
          sx={{
            width: {
              xs: `calc(100% - 160px - 4px)`,
              sm: '50%',
              md: '40%'
            },
            cursor: 'pointer'
          }}
          value={searchKeyword}
          // disabled={isLoadingData}
          onChange={handleSearchInput}
        />
      </Box>

      <TableContainer
        sx={{
          position: 'relative',
          height: basicConstants.TABLE_BASIC_ROW_NUM * basicConstants.TABLE_ROW_HEIGHT,
          minHeight: basicConstants.TABLE_BASIC_ROW_NUM * basicConstants.TABLE_ROW_HEIGHT,
          maxHeight: basicConstants.TABLE_BASIC_ROW_NUM * basicConstants.TABLE_ROW_HEIGHT,
          marginTop: 4,
          borderRadius: '4px',
          border: `1px solid ${theme.palette.grey.w300}`,
          borderColor: (tableData.length > 0 || searchKeyword || isLoadingData) ? theme.palette.grey.w300 : 'transparent'
        }}
      >

        {
          tableData.length > 0 &&
          <>
            <Table stickyHeader>
              <TableHead>
                <TableRow>

                  {
                    headCells.map((headCell, index) => {
                      return (
                        <TableCell
                          key={headCell.id}
                          align={headCell.align}
                          sortDirection={orderBy === headCell.orderName ? order : false}
                          size="small"
                          sx={{
                            padding: '8px 16px',
                            backgroundColor: theme.palette.grey.w300,
                            color: '#fff',
                          }}
                        >
                          {
                            headCell.sortable ?
                              <TableSortLabel
                                active={orderBy === headCell.orderName}
                                direction={orderBy === headCell.orderName ? order : 'asc'}
                                onClick={createSortHandler(headCell.orderName)}
                                sx={{
                                  '&.Mui-active, &.Mui-active .MuiTableSortLabel-icon': {
                                    color: '#fff'
                                  },
                                  '&:hover': {
                                    color: '#fff'
                                  }
                                }}
                              >
                                <FormattedMessage id={headCell.displayName} />
                              </TableSortLabel>
                              :
                              <Typography><FormattedMessage id={headCell.displayName} /></Typography>
                          }
                        </TableCell>
                      )
                    })
                  }
                </TableRow>
              </TableHead>

              <TableBody>
                {
                  tableData.map((row, index) => {
                    return (
                      <TableRow
                        key={row.adAccountId}
                        hover
                      >
                        {
                          headCells.map((cell, index) => {
                            return (
                              <TableCell
                                key={`${cell.id}${index}`}
                                align={cell.align}
                                size="small"
                                sx={{
                                  width: cell.width,
                                  padding: '12px 16px'
                                }}
                              >
                                <RenderTdContent
                                  cell={cell}
                                  row={row}
                                />
                              </TableCell>
                            )
                          })
                        }
                      </TableRow>
                    );
                  })
                }
              </TableBody>

            </Table>
          </>
        }

        <Backdrop
          sx={{
            position: 'absolute',
            zIndex: 500,
            backgroundColor: 'transparent',
            color: theme.palette.grey.w500
          }}
          open={isLoadingData}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {
          tableData.length === 0 && searchKeyword &&
          <BoxFlexColumnCenterCenter
            sx={{
              height: '100%'
            }}
          >
            <FullImage
              src={img_filterNoData}
              alt={intl.formatMessage({ id: "common.modal.noData", defaultMessage: "沒有符合條件的資料" })}
            />
            <Typography align="center" mt={4}>
              <FormattedMessage
                id="account.search.noResultsFound"
                values={{
                  keyword: <span style={{ color: theme.palette.system.main }}>{searchKeyword}</span>,
                  br: <br />,
                }}
              />
            </Typography>
          </BoxFlexColumnCenterCenter>
        }
        {
          tableData.length === 0 && !searchKeyword && !isLoadingData &&
          <BoxFlexColumnCenterCenter
            sx={{
              height: '100%'
            }}
          >
            <FullImage
              src={img_noData}
              alt={intl.formatMessage({ id: "account.image.noAccountsConnected", defaultMessage: "未串接任何廣告帳號" })}
            />
            <Typography my={4}><FormattedMessage id="account.noAccountsAuthorized" /></Typography>
            <LinkCustom to={urlConstants.PAGE_AD_ACCOUNTS_CREATE}>
              <ButtonSyetemMain variant="contained" disableElevation><FormattedMessage id="account.button.authorizeNow" /></ButtonSyetemMain>
            </LinkCustom>
          </BoxFlexColumnCenterCenter>
        }
      </TableContainer>

      {
        tableData.length > 0 &&
        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 25, 50, 100]}
          count={tableDataLength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
        />
      }

      <AdAccountModal
        modalType={modalType}
        modalData={currentAccount}
        handleSubmit={handleSubmit}
        handleCloseModal={() => {
          setModalType('');
          setCurrentAccount(false);
        }}
      />

      <AlertMessage
        type="noAction"
        isOpen={alertContent.open}
        message={alertContent.message}
        handleClose={() => {
          setAlertContent({
            open: false,
            message: ''
          });
        }}
      />

    </>
  );
}

export default AdAccounts;